import { render } from "./FormSearchCompo.vue?vue&type=template&id=bfc65e2e&scoped=true"
import script from "./FormSearchCompo.vue?vue&type=script&lang=js"
export * from "./FormSearchCompo.vue?vue&type=script&lang=js"

import "./FormSearchCompo.vue?vue&type=style&index=0&id=bfc65e2e&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\VueJS\\jobapply-TH\\jobapplyvuejs\\Vue\\vue-crud-netcoreapi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc65e2e"]])

export default __exports__